import { FieldProps } from "..";
import { IconPosition } from "@/core/types/types";
import DynamicMaterialIcons from "../../MaterialIcons/MaterialIcons";
import useDynamicSVGImport from "@/core/hooks/useDynamicSVGImport/useDynamicSVGImport";
import NavigationButton from "./NavigationButton";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { requiredFieldsArePresent } from "@/core/utils/requiredFieldsValidator";
import { Typography } from "@mui/material";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";

const IconForButton = ({ field }: FieldProps) => {
  const iconName: string | undefined =
    field.properties?.[IconPosition.IconBefore] ||
    field.properties?.[IconPosition.IconAfter] ||
    undefined;
  const iconSrc: string = iconName ? `images/icons/${iconName}.svg` : "";
  const { SvgIcon, loading } = useDynamicSVGImport(iconSrc);
  const startsWithSvgElement = SvgIcon && SvgIcon.startsWith("<svg");
  const MaterialIcon = iconName && DynamicMaterialIcons[iconName];
  return MaterialIcon ? (
    <MaterialIcon />
  ) : iconSrc && !loading && startsWithSvgElement ? (
    <span
      style={{ width: "20px" }}
      dangerouslySetInnerHTML={{ __html: SvgIcon as string }}
    />
  ) : null;
};

const ButtonField = ({ field }: FieldProps) => {
  const { properties } = field;
  const startIcon: React.ReactNode | undefined = properties?.[
    IconPosition.IconBefore
  ] && <IconForButton field={field} />;
  const endIcon: React.ReactNode | undefined = properties?.[
    IconPosition.IconAfter
  ] && <IconForButton field={field} />;
  const subtext: React.ReactNode | undefined = properties?.subtext && (
    <Typography className="subtext">{t(properties?.subtext)}</Typography>
  );

  const [requiredFieldsAreInPlace, setRequiredFieldsAreInPlace] =
    useState(false);
  const { control, watch } = useFormContext();
  const formValues = watch();

  useEffect(() => {
    // Using setTimeout, because control._fields gets updated at the end of an event loop (and not along with formValues)
    setTimeout(() => {
      const requiredFieldsAreFilled = requiredFieldsArePresent(
        control._fields,
        formValues,
        properties?.validationKey
      );
      setRequiredFieldsAreInPlace(requiredFieldsAreFilled);
    }, 50);
  }, [formValues]);

  // TODO: Add opportunity to use both icon-before and icon-after position
  return (
    <NavigationButton
      field={field}
      startIcon={startIcon}
      endIcon={endIcon}
      subtext={subtext}
      requiredFieldsAreFilled={requiredFieldsAreInPlace}
    />
  );
};

export default ButtonField;
